import { useEffect, useState } from "react"
import { PanelLoader } from "../../../../../features/ui"
import { BookmarkButton } from "../../../../../features/bookmarks"
import { RoutePath } from "../../../../../features/routes"
import { useDriverLoaders } from "../../../loaders/driverLoaders"
import { TableName } from "../../../../../tables"
import { ListLoaderWrapper } from "../../../../../features/data-types"
import { DeliveryRoadmap, Driver, Roadmap } from "../../../state/types"
import { DriverList } from "./driverList"
import { useRoadmapLoaders } from "../../../loaders/roadmapLoaders"
import { Operation, useOperationLoaders } from "../../../../operations"
import { Delivery, useDeliveryLoaders } from "../../../../deliveries"

export const Loader = () => {
    const [drivers, setDrivers] = useState<Driver[]>([])
    const [roadmaps, setRoadmaps] = useState<Roadmap[]>([])
    const [deliveryRoadmaps, setDeliveryRoadmaps] = useState<DeliveryRoadmap[]>([])
    const [deliveries, setDeliveries] = useState<Delivery[]>([])
    const [operations, setOperations] = useState<Operation[]>([])
    const [ready, setReady] = useState(false)

    const driverLoaders = useDriverLoaders()
    const roadmapLoaders = useRoadmapLoaders()
    const deliveryLoaders = useDeliveryLoaders()
    const operationLoaders = useOperationLoaders()

    const populate = async () => {
        const { loadAllDrivers } = driverLoaders()
        setDrivers(await loadAllDrivers(true))
        const { loadAllRoadmaps, loadRoadmapsDeliveriesLinks } = roadmapLoaders()
        const loadedRoadmaps = await loadAllRoadmaps(true)
        setRoadmaps(loadedRoadmaps)
        const loadedDeliveryRoadmaps = await loadRoadmapsDeliveriesLinks(loadedRoadmaps.map(roadmap => roadmap.id), true)
        setDeliveryRoadmaps(loadedDeliveryRoadmaps)
        const { loadDeliveries } = deliveryLoaders()
        const loadedDeliveries = await loadDeliveries(loadedDeliveryRoadmaps.map(deliveryRoadmap => deliveryRoadmap.deliveryId))
        setDeliveries(loadedDeliveries)
        const { loadDeliveriesOperations } = operationLoaders()
        const loadedOperations = await loadDeliveriesOperations(loadedDeliveries)
        setOperations(loadedOperations)
    }

    useEffect(() => {
        populate().then(() => setReady(true))
    }, [])

    return (
        <PanelLoader
            title="Conductores"
            ready={ready}
            titleRight={<BookmarkButton routePath={RoutePath.DRIVERS} />}
        >
            <DriverList
                drivers={drivers}
                roadmaps={roadmaps}
                deliveryRoadmaps={deliveryRoadmaps}
                deliveries={deliveries}
                operations={operations}
            />
        </PanelLoader>
    )
}

export const DriverListLoader = () => (
    <ListLoaderWrapper table={TableName.DRIVERS}>
        <Loader />
    </ListLoaderWrapper>
)
